import {
    deletePushNotificationSubscription,
    getPushNotificationConfig,
    savePushNotificationSubscription,
    sendPushNotificationTest,
} from "./api";

function urlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = `${base64String}${padding}`.replace(/-/g, "+").replace(/_/g, "/");
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i += 1) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

export function getPushSupportStatus() {
    if (typeof window === "undefined" || typeof navigator === "undefined") {
        return { supported: false, reason: "Browser notifications are not available here." };
    }
    if (!("serviceWorker" in navigator)) {
        return { supported: false, reason: "Browser notifications are not supported by this browser." };
    }
    if (!("PushManager" in window) || !("Notification" in window)) {
        return { supported: false, reason: "Browser notifications are not supported by this browser." };
    }
    if (!window.isSecureContext) {
        return { supported: false, reason: "Browser notifications need a secure portal connection." };
    }
    return { supported: true, reason: "" };
}

export async function getExistingPushSubscription() {
    const support = getPushSupportStatus();
    if (!support.supported) return null;
    const registration = await navigator.serviceWorker.ready;
    return registration.pushManager.getSubscription();
}

export async function enableAdminPushNotifications() {
    const support = getPushSupportStatus();
    if (!support.supported) {
        return { ok: false, message: support.reason };
    }

    const config = await getPushNotificationConfig();
    if (!config?.ok) {
        return { ok: false, message: config?.message || "Could not load notification settings." };
    }
    if (!config.configured || !config.publicKey) {
        return { ok: false, message: "Browser notifications are not configured yet." };
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
        return { ok: false, permission, message: "Notifications are blocked for this browser." };
    }

    const registration = await navigator.serviceWorker.ready;
    const existing = await registration.pushManager.getSubscription();
    const subscription =
        existing ||
        (await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(config.publicKey),
        }));

    const saved = await savePushNotificationSubscription(subscription.toJSON());
    if (!saved?.ok) {
        return { ok: false, message: saved?.message || "Could not save notification settings." };
    }
    return { ok: true, subscription };
}

export async function disableAdminPushNotifications() {
    const subscription = await getExistingPushSubscription();
    if (subscription) {
        await deletePushNotificationSubscription(subscription.endpoint);
        await subscription.unsubscribe().catch(() => false);
    }
    return { ok: true };
}

export async function sendAdminPushNotificationTest() {
    return sendPushNotificationTest();
}
